import { Pegasus } from 'corso-types';
import DescriptionList, { Description } from '~/components/DescriptionList';

export default function EventCustomizeReturnShipmentDisplay({
  params,
}: {
  params: Pegasus.EventCustomizeReturnShipment['params'];
}) {
  const {
    returnParcels,
    fileUrl,
    fileUrlCta,
    isApplicablePerLineItemQuantity,
  } = params;

  const eventDescriptions: Description[] = [
    {
      term: 'Apply per item quantity',
      details: isApplicablePerLineItemQuantity ? 'Yes' : 'No',
    },
  ];
  if (fileUrlCta) {
    eventDescriptions.push({ term: 'File URL CTA', details: fileUrlCta });
  }
  if (fileUrl) {
    eventDescriptions.push({ term: 'File URL', details: fileUrl });
  }

  return (
    <div className="mt-2 flex flex-col gap-4">
      {returnParcels.map((parcel) => (
        <div
          key={`${parcel.name ?? 'no-parcel-name'}-${parcel.length}x${parcel.width}x${parcel.height}-${parcel.weight}`}
        >
          <p className="font-medium">{parcel.name}</p>
          <div className="m-2">
            <DescriptionList
              descriptions={[
                {
                  term: 'Dimensions',
                  details: `${parcel.length} x ${parcel.width} x ${parcel.height} in`,
                },
                {
                  term: 'Weight',
                  details: `${parcel.weight ?? '—'} oz`,
                },
              ]}
              layoutType="list"
            />
          </div>
        </div>
      ))}

      <DescriptionList descriptions={eventDescriptions} layoutType="list" />
    </div>
  );
}
